import { FC } from "react";
import LogoSVG from "../resources/svg/LogoSVG";
import { useTranslation } from "react-i18next";
import InstagramIconSVG from "../resources/svg/InstagramIconSVG";
import SendEmailButton from "../resources/components/SendEmailButton";
import { currentYear, email, instagramLink1, instagramLink2, phone, website } from "../../Config";
import PrivacyPolicyPopup from "./PrivacyPolicyPopup";
import useScreenSize from "../../custom-hooks/useScreenSize";

const Footer: FC = () => {
    const { upTo900, moreOrEqual900 } = useScreenSize();
    const { t } = useTranslation();

    return (
        <div className="bg-[#F1F1F1]">
            <div id="contacts" className="relative pt-20 pb-[50px] dmax2:pt-[60px] dmax2:pb-[30px]">
                <div className="relative flex flex-col justify-center items-center left-0 right-0 mx-auto h-full">
                    <div className="tmin4:flex tmax4:grid tmax4:grid-cols-2 tmax4:gap-[50px] justify-between dmin2:w-[1280px] di8:w-[1138px] di7:w-[960px] ti3:w-[860px] td8:w-[767px] ti7:w-[600px] ti8:w-[500px] mi2:w-[440px] mi1:w-[360px] mi5:w-[320px]">
                        <LogoSVG />
                        <div className="flex flex-col w-fit tmax4:justify-self-end">
                            <p className="H16 dmax2:H14 w-fit">{t("footer.studioName")}</p>
                            <p className="H16 dmax2:H14 w-fit">{t("footer.name1")}</p>
                            <p className="H16 dmax2:H14 w-fit">{t("footer.name2")}</p>
                            <p className="H16 dmax2:H14 w-fit">{t("footer.address1")}</p>
                            <p className="H16 dmax2:H14 w-fit">{t("footer.address2")}</p>
                        </div>
                        {moreOrEqual900 && (
                            <>
                                <div className="flex flex-col w-fit">
                                    <p className="H16 dmax2:H14 mb-3">{t("footer.telephone", { value: phone })}</p>
                                    <p className="H16 dmax2:H14 mb-3">{email}</p>
                                    <a
                                        href={`https://${website}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="H16 dmax2:H14 mb-3 underline underline-offset-2"
                                    >
                                        {website}
                                    </a>
                                </div>
                                <div className="flex">
                                    <InstagramIconSVG className="mr-2" />
                                    <div className="flex flex-col">
                                        <a
                                            className="H16 dmax2:H14 mb-2 underline underline-offset-2"
                                            href={instagramLink2}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Instagram
                                        </a>
                                        <a
                                            className="H16 dmax2:H14 underline underline-offset-2"
                                            href={instagramLink1}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Instagram
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}
                        {upTo900 && (
                            <>
                                <div className="flex">
                                    <InstagramIconSVG className="mr-2" />
                                    <div className="flex flex-col">
                                        <a
                                            className="H16 dmax2:H14 mb-2 underline underline-offset-2"
                                            href={instagramLink2}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Instagram
                                        </a>
                                        <a
                                            className="H16 dmax2:H14 underline underline-offset-2"
                                            href={instagramLink1}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Instagram
                                        </a>
                                    </div>
                                </div>
                                <div className="flex flex-col w-fit justify-self-end">
                                    <p className="H16 dmax2:H14 mb-3">{t("footer.telephone", { value: phone })}</p>
                                    <p className="H16 dmax2:H14 mb-3">{email}</p>
                                    <a
                                        href={`https://${website}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="H16 dmax2:H14 mb-3 underline underline-offset-2"
                                    >
                                        {website}
                                    </a>
                                </div>
                            </>
                        )}
                        {moreOrEqual900 && <SendEmailButton />}
                    </div>
                    {upTo900 && <SendEmailButton className="mmin1:w-[360px] mmax1:w-[320px] mt-[50px]" />}
                    <div className="flex flex-col w-[259px] mt4:w-[360px] mi5:w-[320px] text-center mt-10">
                        <PrivacyPolicyPopup />
                        <p className="H16 text-[#848484]">{t("footer.copyright", { value: currentYear })}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
